/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OTPRequest
 */
export interface OTPRequest {
    /**
     * 
     * @type {string}
     * @memberof OTPRequest
     */
    phone_number: string;
}

/**
 * Check if a given object implements the OTPRequest interface.
 */
export function instanceOfOTPRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "phone_number" in value;

    return isInstance;
}

export function OTPRequestFromJSON(json: any): OTPRequest {
    return OTPRequestFromJSONTyped(json, false);
}

export function OTPRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OTPRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'phone_number': json['phone_number'],
    };
}

export function OTPRequestToJSON(value?: OTPRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'phone_number': value.phone_number,
    };
}

